<form [formGroup]="configurationFormFileAcodis">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.acodis.acodis-workflow' |
        translate}}</label>
      <ejs-dropdownlist #acodisWorkflowId formControlName="acodisWorkflowId" [showClearButton]="false"
        [dataSource]="acodisWorkflows" [fields]="fields">
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormFileAcodis.controls.acodisWorkflowId"></app-error-messages>
    </div>
  </div>
</form>